import { sample } from 'effector';
import { format } from 'date-fns';
import { signout } from '@features/common';
import { $data as $statuses } from '@features/tickets-status-select';
import { $openedId } from '../../detail-sdui-opened-id';
import { $sduiTicketData } from '../../detail-sdui/model';
import { updateTicketList } from '../../page';
import {
  $relatedTickets,
  $selectRow,
  $successRelatedDelete,
  $tableData,
  fxGetList,
  fxRelatedDelete,
  refreshList,
  RelatedTicketsGate,
  resetSuccessRelatedDelete,
  startRelatedDelete,
} from '../model';

sample({
  clock: RelatedTicketsGate.open,
  target: fxGetList,
});

sample({
  clock: refreshList,
  source: RelatedTicketsGate.state,
  fn: ({ id }) => ({ id }),
  target: fxGetList,
});

$selectRow.reset([fxGetList.doneData, signout]);

sample({
  clock: fxGetList.doneData,
  source: $statuses,
  fn: (statuses, { tickets }) =>
    tickets.map(
      ({ id, number, description, status, created_at, type, object, applicant }) => ({
        id: String(id),
        number: { number, id },
        description,
        status: {
          id: status,
          label: statuses?.find(({ id }) => id === status)?.title ?? '',
        },
        created_at: format(new Date(created_at), 'dd.MM.yyy HH:mm'),
        type: type ?? [],
        objectTitle: object?.title ?? '',
        applicantFullname: applicant.fullname,
        applicantPnone: applicant.phone,
      })
    ),
  target: $tableData,
});

sample({
  clock: $sduiTicketData,
  fn: ({ related }) => related,
  target: $relatedTickets,
});

sample({
  clock: startRelatedDelete,
  source: { selectRow: $selectRow, openedId: $openedId },
  fn: ({ selectRow, openedId }) => ({
    id: openedId!,
    related: selectRow,
  }),
  target: fxRelatedDelete,
});

$successRelatedDelete.reset([resetSuccessRelatedDelete, signout]);

sample({
  clock: fxRelatedDelete.done,
  fn: () => true,
  target: [$successRelatedDelete, refreshList, updateTicketList],
});
